export class Global {

}

export enum OperacoesWebAPI {
    Login = 'login'  ,
    Escolaridade = 'escolaridade',
    DadosCadastrais = 'dadosCadastrais',
    DadosSuporte = 'dadosSuporte',
    InstituicaoEncaminhamento = 'instituicaoEncaminhamento',
    MeioComunicacao = "meioComunicacao",
    MotivoEscolaridade = "motivoEscolaridade",
    EstadoEntradaBrasil = "estadoEntradaBrasil",
    Municipio = 'municipio',
    MunicipioEntradaBrasil = "municipioEntradaBrasil",
    ModoEntrada = "modoEntrada",
    Bloqueio = "bloqueio",
    PontoFiscalizacao = "pontoFiscalizacao",
    TipoDocumento = "tipoDocumento",
    Operacao = "operacao"
}

export enum StringsSessionStorage {        
        RequestRenewToken = 'request-renew-token',
        ExpirationToken = 'expiration-token',
        CustomToken = 'custom-token'
}
export enum StringsCookie {
    CustomToken = 'custom-token'
}


export const temValor = (objeto: any): boolean => { return objeto !== undefined && objeto !== null }